import { convertLexicalJsonToQuery } from '#pplx/frontend/apps/ask/ask-input/query-serialization/lexicalNodeToQuery.js';
import { useCallback } from 'react';
/** Keeps the current editor's source mentions when a suggestion supplies the submitted query. */
export function useAskInputSubmitWithMentions({ json, handleSubmit, }) {
    return useCallback((params) => {
        const { mentions } = convertLexicalJsonToQuery(json?.root);
        return handleSubmit({
            ...params,
            mentions: mentions.length > 0 ? mentions : undefined,
        });
    }, [json, handleSubmit]);
}
//# sourceMappingURL=useAskInputSubmitWithMentions.js.map